







































import { CrudList, DataTable, NoDataFound } from '../../components';

import { CrudDataTypeEnum } from '../../enums';

import { CrudListMixin } from '../../mixins/crud-list.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'users-list',
  components: {
    CrudList,
    DataTable,
    NoDataFound
  },
  mixins: [CrudListMixin],
  data: function () {
    const messages = this.$epb.messages.tools.users;
    return {
      dataType: CrudDataTypeEnum.USERS,
      routes: {
        create: ROUTER_CONSTS.routes.users.create,
        update: ROUTER_CONSTS.routes.users.update
      },
      columns: [
        {
          id: 'username',
          text: messages.fields.username.label
        }, {
          id: 'fullName',
          text: messages.fields.fullName.label
        }, {
          id: 'email',
          text: messages.fields.email.label
        }, {
          id: 'enabled',
          text: messages.fields.enabled.label
        }
      ],
      messages: messages
    };
  }
};
